export default __webpack_public_path__ + "static/media/page-title-contacts-uz.7b6cce45.svg";